import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import { NodeEnv, DOMAIN, REALM, SITE } from './constants';
import { PlacementType } from "../models";
// eslint-disable-next-line no-console
var metricsConsoleErrorHandler = function (err) { return console.error(err); };
var makeMetricsDriver = function () {
    if (process.env.NODE_ENV !== NodeEnv.production) {
        var metricsDriver = new KatalMetricsDriverArrayCollector();
        //  Attach to global window object so tests can see it
        window.metricsDriver = metricsDriver;
        return metricsDriver;
    }
    return new KatalMetricsDriverSushi.Builder()
        // FIXME: onboard to katal-webpack-plugin to dynamically pass domain realm i.e.DOMAIN['prod']
        .withDomainRealm(DOMAIN['prod'], REALM['us-east-1'])
        .withErrorHandler(metricsConsoleErrorHandler)
        .build();
};
var makePublisher = function () {
    var metricsDriver = makeMetricsDriver();
    var initialMetricsContext = new KatalMetrics.Context.Builder()
        // FIXME: onboard to katal-webpack-plugin to dynamically pass site
        .withSite(SITE['prod'] || 'AACChrome')
        .withServiceName('AcesCommunicationsApi')
        .build();
    return new KatalMetrics.Publisher(metricsDriver, metricsConsoleErrorHandler, initialMetricsContext);
};
export var KatalMetricsPublisher = makePublisher();
export var notificationMetricsMap = new Map(Object.values(PlacementType).map(function (placementType) { return [
    placementType,
    KatalMetricsPublisher.newChildActionPublisherForMethod(placementType),
]; }));
